import React from 'react';

export default user => {
  const columns = [
    {
      title: 'Etapa',
      field: 'step_name',
      editable: 'never',
      width: 150,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Descrição Etapa',
      field: 'step_description',
      editable: 'never',
      width: 400,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Sub-etapa',
      field: 'substep_name',
      editable: 'never',
      width: 150,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Descrição Etapa',
      field: 'substep_description',
      editable: 'never',
      width: 400,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
